'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ComposerLabel } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatComposerUtilityClasses } from "./chatComposerClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatComposerLabel');
const ChatComposerLabelStyled = styled('label', {
  name: 'MuiChatComposer',
  slot: 'Label',
  overridesResolver: (_, styles) => styles.label
})(({
  theme
}) => ({
  display: 'block',
  fontSize: theme.typography.caption.fontSize,
  lineHeight: theme.typography.caption.lineHeight,
  color: (theme.vars || theme).palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  paddingInline: theme.spacing(0.5)
}));
const ChatComposerLabel = /*#__PURE__*/React.forwardRef(function ChatComposerLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatComposerLabel'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatComposerUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ComposerLabel, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      label: slots?.label ?? ChatComposerLabelStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      label: _extends({
        className: clsx(classes.label, className),
        sx
      }, slotProps?.label)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatComposerLabel.displayName = "ChatComposerLabel";
process.env.NODE_ENV !== "production" ? ChatComposerLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Label text. Falls back to the locale text `composerInputAriaLabel` when
   * omitted, so the default is consistent with the textarea's `aria-label`.
   */
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The `id` of the textarea this label is associated with.
   * Passed directly to the native `htmlFor` attribute.
   * When provided, the label is semantically linked to the textarea so that
   * clicking the label focuses the input and screen readers announce it on focus.
   */
  htmlFor: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatComposerLabel };